import { type ExperimentValue } from '@stone-payments/experiment/src/lib/types'

export enum SweepAccountsHomeContentEnum {
  Months = 'months',
  ProductName = 'product_name',
  ReturnAmount = 'return_amount'
}

type SweepAccountsHomeBalanceCard = {
  title: string
  product_default?: string
}

type SweepAccountsHomeBalanceHistory = {
  title: string
  button: string
  subtitle: string
  empty_tooltip: string
  empty_description: string
}

type SweepAccountsHomeKnowMoreAbout = {
  title: string
  button: string
}

type SweepAccountsHomeMoreProfitability = {
  title: string
  button: string
  description: string
}

export type SweepAccountsHomeContent = {
  page_title: string
  balance_card: SweepAccountsHomeBalanceCard
  balance_history: SweepAccountsHomeBalanceHistory
  know_more_about: SweepAccountsHomeKnowMoreAbout
  more_profitability: SweepAccountsHomeMoreProfitability
}

export type SweepAccountsHomeExperimentPayload = {
  page_title?: string
  balance_card?: Partial<SweepAccountsHomeBalanceCard>
  balance_history?: Partial<SweepAccountsHomeBalanceHistory>
  know_more_about?: Partial<SweepAccountsHomeKnowMoreAbout>
  more_profitability?: Partial<SweepAccountsHomeMoreProfitability>
  ignore_default_content?: boolean
}

export const defaultSweepAccountsHomeContent: SweepAccountsHomeContent = {
  page_title: '*Rendimentos* no saldo',
  balance_card: {
    title: 'Quanto já rendeu nos últimos {months} meses'
  },
  balance_history: {
    title: 'Histórico',
    button: 'Confira histórico detalhado',
    subtitle: 'Toque na coluna pra conferir o rendimento no mês.',
    empty_tooltip: 'Aqui você vai encontrar um gráfico com os valores por mês.',
    empty_description:
      'Acompanhe os próximos rendimentos por aqui. Qualquer valor no seu saldo da Conta Stone pode render.'
  },
  know_more_about: {
    title: 'Como seu saldo rende?',
    button: 'Entenda'
  },
  more_profitability: {
    title: 'Mais rentabilidade',
    button: 'Conhecer',
    description: 'Outras opções com rendimentos superiores.'
  }
}

export const defaultSweepAccountsHomeExperimentPayload: ExperimentValue<SweepAccountsHomeExperimentPayload> = {
  value: 'control',
  payload: defaultSweepAccountsHomeContent
}
